import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export class sectorslist{
  constructor(){}
  public sectorId : number;
  public sector : string;
}

export interface SectorBrandData {
  name: string;
  pipelineValue: number;
  weightedValue: number;
}


@Injectable({
  providedIn: 'root'
})

export class SectorsService {
  
  constructor(private httpClient:HttpClient) { }

  
  /**
   * getsectorsList
   */
  public getsectorsList() {
    let userEmail = sessionStorage.getItem('loginUserName');
    return this.httpClient.get<sectorslist[]>('api/v1/sector/byuser/'+ userEmail );
  }

  retriveSectors() : Observable<sectorslist[]> {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.get<sectorslist[]>('api/v1/sector/',{headers})
    .pipe(catchError(this.errorHandler));
  }

  public createSector(obj : any) : Observable<any>{
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.post<any>('/api/v1/sector/' , obj , {headers}).pipe(catchError(this.errorHandler));
  }

  updateSector(bean: any): Observable<any> {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.put<any>('/api/v1/sector/' , bean , {headers}).pipe(catchError(this.errorHandler));
  }

  public deleteSector(Id: number){
    return this.httpClient.delete('api/v1/sector/' + Id);
  }

  errorHandler(error: HttpErrorResponse){
    console.log(error.message);
    return throwError(error.message || 'Server Error');

  }
}
